module.exports = __webpack_public_path__ + "img/9.a824ad0f.png";